import { useState } from 'react';

export const useFileHandler = () => {
  const [files, setFiles] = useState([]);

  const addFiles = (newFiles) => {
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const removeFile = (indexToRemove) => {
    setFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToRemove));
  };

  const clearFiles = () => {
    setFiles([]);
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    addFiles(selectedFiles);
    event.target.value = null; // Reset input to allow selecting the same file again
  };

  const handlePaste = (event) => {
    const clipboardFiles = Array.from(event.clipboardData.files);
    if (clipboardFiles.length > 0) {
      event.preventDefault(); // Prevent pasting file path as text
      // Filter for common image types
      const imageFiles = clipboardFiles.filter((file) => file.type.startsWith('image/'));
      if (imageFiles.length > 0) {
        addFiles(imageFiles);
      }
    }
  };

  return {
    files,
    addFiles,
    removeFile,
    clearFiles,
    handleFileChange,
    handlePaste,
  };
};